<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="mt-8" no-gutters>
        <div id="canvas-wrapper" class="d-none" />

        <v-col class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <v-autocomplete
              v-model="qrType"
              :items="types"
              append-icon="mdi-image-outline"
              dense
              class="contentinfo"
              label="فرمت"
              outlined
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-data-qrType`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="فرمت"
            />
          </div>
        </v-col>

        <v-col v-if="qrType !== 'selectable'" class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <v-autocomplete
              v-model="qrSize"
              :items="sizes"
              append-icon="mdi-format-list-bulleted-type"
              dense
              class="contentinfo"
              label="سایز خروجی"
              outlined
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-data-qrSize`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="سایز خروجی"
            />
          </div>
        </v-col>

        <v-col v-else class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <v-autocomplete
              v-model="extension"
              :items="multipleType"
              append-icon="mdi-export"
              dense
              class="contentinfo"
              label="نوع فایل"
              outlined
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-data-extension`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="نوع فایل"
            />
          </div>
        </v-col>

        <v-col class="pa-2" cols="12">
          <div class="rowinfo">
            <v-btn
              :loading="loading"
              class="btn-download ma-0"
              @click="downloadFile"
            >
              <v-icon class="me-2">mdi-progress-download</v-icon>
              دانلود
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-download`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود"
            />
          </div>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QRCodeStyling from "qr-code-styling";

let qrCode = null;

export default {
  name: "downloadFile",

  props: {
    info: [Object, undefined],
    visitName: String,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "downloadFile",
      sizes: [
        { text: "پیشفرض", value: "default" },
        { text: "100", value: "100" },
        { text: "200", value: "200" },
        { text: "300", value: "300" },
        { text: "400", value: "400" },
        { text: "500", value: "500" },
        { text: "600", value: "600" },
        { text: "700", value: "700" },
        { text: "800", value: "800" },
        { text: "900", value: "900" },
        { text: "1000", value: "1000" },
      ],
      types: [
        { text: "PNG", value: "png" },
        { text: "SVG", value: "svg" },
        { text: "JPEG", value: "jpeg" },
        { text: "WEBP", value: "webp" },
        { text: "600*600", value: "selectable" },
      ],
      qrSize: "default",
      qrType: "png",
      extension: "png",
      loading: false,
    };
  },

  computed: {
    getVisitName() {
      let str = this.qrSize !== "default" ? `-${this.qrSize}` : "";
      return this.visitName.replace(/\s+/g, "_") + "" + str;
    },
    multipleType() {
      return this.types.filter((item) => item.value !== "selectable");
    },
    computedFormat() {
      return this.qrType === "selectable" ? this.extension : this.qrType;
    },
  },
  mounted() {},
  methods: {
    async downloadSvgFromUrl() {
      const svgUrl = this.info.img_url || this.info.data?.data?.image;
      const fileName = this.getVisitName || "qr";
      const extension = this.computedFormat || "svg";
      if (extension === "svg") {
        const response = await fetch(svgUrl);
        if (!response.ok)
          this.$toast.error("بارگیری کیوآر با مشکل مواجه شد. مجدد تلاش کنید");
        const svgBlob = await response.blob();
        const url = window.URL.createObjectURL(svgBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${fileName}.svg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const size = this.qrSize !== "default" ? Number(this.qrSize) : 300;
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = svgUrl;
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = () => reject(new Error("Failed to load SVG"));
        });
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, size, size);
        const mimeType =
          {
            png: "image/png",
            jpeg: "image/jpeg",
            webp: "image/webp",
          }[extension] || "image/png";
        canvas.toBlob((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `${fileName}.${extension}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, mimeType);
        this.loading = false;
      }
    },
    async downloadFile() {
      this.loading = true;
      if (this.info.data.data.tab_design === 1) {
        await this.downloadSvgFromUrl();
      } else {
        qrCode = new QRCodeStyling(this.computedValue);
        qrCode.append(
          document.getElementById(this.canvasId ?? "canvas-wrapper")
        );
        let obj = {};

        if (this.info && this.info.qr && typeof this.info.qr === "string") {
          try {
            obj = JSON.parse(this.info.qr);
          } catch (e) {
            console.log("error in read qr: ", this.info);
          }
        } else obj = this.info.qr;

        if (this.qrType === "selectable") {
          obj = {
            ...obj,
            width: 600,
            height: 600,
            backgroundOptions: {
              color: "#FFFFFFFF",
            },
            qrOptions: {
              typeNumber: 2,
              mode: "Byte",
              errorCorrectionLevel: "H",
            },
          };
        } else if (this.qrSize !== "default") {
          obj.width = obj.height = Number(this.qrSize);
        }

        console.log("obj: ", obj);

        this.$nextTick(async () => {
          qrCode.update(obj);
          await qrCode.download({
            name: this.getVisitName || "qr",
            extension: this.computedFormat || "svg",
          });
          this.loading = false;
        });
      }
    },
  },
};
</script>

<style scoped></style>
